// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--28Lgr","photo":"a10a3f92e9--photo--1cW5N","cell":"a10a3f92e9--cell--18Qs0"};